import { RawAxiosRequestHeaders } from 'axios';

export function setAuthHeader(headers: RawAxiosRequestHeaders, token: string): void  {
	headers['Authorization'] = `Bearer ${token}`;
}
